﻿export interface Section {
	SectionId: number | null;
	SectionName: string;
	SectionFamilyId: number | null;
	SectionFamilyName: string;
	SortOrder: number | null;
	BilletSize: number | null;
	Description: string | null;
	TonsPerHour: number | null;
	TargetTPH: number | null;
	MillYield: number | null;
	FinishedYield: number | null;
	LBsPerFoot: number | null;
	IsFirstSection: boolean;
	IsLastSection: boolean;
	IsActive: boolean | null;
}

export const SECTION_INITIAL_VALUES: Section = {
	SectionId: null,
	SectionName: "",
	SectionFamilyId: null,
	SectionFamilyName: "",
	SortOrder: null,
	BilletSize: null,
	Description: null,
	TonsPerHour: null,
	TargetTPH: null,
	MillYield: null,
	FinishedYield: null,
	LBsPerFoot: null,
	IsFirstSection: false,
	IsLastSection: false,
	IsActive: true,
};

export interface SectionGap {
	SectionId: string;
	StandId: number | null;
	StandName: number | null;
	SetpointGap: number;
	Comments: string;
}
